import type { ImpactOption } from "~/components/donate/DonateImpactOptions.vue";

/**
 * Ne garde que les montants d'impact affichables (montant > 0, titre non vide),
 * 4 au plus. L'API valide déjà à l'écriture ; ce filet protège l'affichage des
 * valeurs venues de l'aperçu (adresse / postMessage) ou d'une donnée abîmée.
 */
export function nettoyerMontantsImpact(raw: unknown): ImpactOption[] {
  if (!Array.isArray(raw)) return [];
  return raw
    .map((o) => {
      const r = (o ?? {}) as { amount?: unknown; label?: unknown; description?: unknown; image?: unknown };
      const description = typeof r.description === "string" ? r.description.trim().slice(0, 160) : "";
      const image = typeof r.image === "string" ? r.image.trim() : "";
      return {
        amount: Number(r.amount),
        label: String(r.label ?? "").trim().slice(0, 60),
        ...(description ? { description } : {}),
        ...(image ? { image } : {}),
      };
    })
    .filter((o) => Number.isFinite(o.amount) && o.amount > 0 && o.label.length > 0)
    .slice(0, 4);
}

/**
 * Don récurrent : « 20 € / mois » sur les cartes d'impact (décision Karim
 * 2026-10-12). Don unique : pas de suffixe.
 */
export function suffixePeriodeImpact(
  isSubscription: boolean,
  period: string | null | undefined,
  t: (key: string) => string,
): string | null {
  if (!isSubscription) return null;
  return t(`don.periodes.${period === "weekly" ? "semaine" : period === "monthly" ? "mois" : "an"}`);
}
